import {useEffect, useState} from "react";

import moment from "moment";
import {useStore} from "../../../../../../hooks/useStore";
import {useFetch} from "../../../../../../hooks/useFetch";

export const useCourierWalletInvoiceSubTab = ({
    courier, 
    canRender = false, 
    selectedDateRange = [moment().subtract(7, "day"), moment()],
    onDateRangeChange = () => {}
}) => {
    const stores = useStore();
    const [selectedPaymentInvoice, setSelectedPaymentInvoice] = useState(null);

    const [paymentInvoicesResultLoading, paymentInvoicesResult] = useFetch({
        fetchFn: stores.walletStore.getCourierPaymentInvoices.bind(null, {
            courierId: courier?._id,
            startDate: selectedDateRange?.[0]?.format("YYYY-MM-DD"),
            endDate: selectedDateRange?.[1]?.format("YYYY-MM-DD")
        }),
        dependencies: [courier?._id, JSON.stringify(selectedDateRange), canRender],
        initialCall: canRender,
        condition: Boolean(courier?._id) && canRender
    });

    useEffect(() => {
        resetSelectedPaymentInvoice();
    }, [canRender]);

    const resetSelectedPaymentInvoice = () => {
        setSelectedPaymentInvoice(null);
    };

    const handleDateRangeChange = async dates => {
        resetSelectedPaymentInvoice();
        if (!dates || !dates[0] || !dates[1]) {
            onDateRangeChange(null);
            return;
        }
        onDateRangeChange([moment(dates[0]), moment(dates[1])]);
    };

    const handlePaymentInvoiceSelect = paymentInvoiceId => {
        const item = paymentInvoicesResult?.invoices?.find(
            invoice => invoice?._id?.toString() === paymentInvoiceId?.toString()
        );

        setSelectedPaymentInvoice(item);
    };

    return {
        paymentInvoicesResultLoading,
        paymentInvoices: paymentInvoicesResult?.invoices || [],
        selectedPaymentInvoice,
        selectedDateRange,
        handleDateRangeChange: onDateRangeChange || handleDateRangeChange,
        handlePaymentInvoiceSelect
    };
};
